module.exports = __webpack_public_path__ + "assets/pickup-b0cff0.svg";